import React from 'react';
import Countdown from 'react-countdown';
import dateFormat from 'date-fns/format';
import { formatISO, differenceInMinutes } from 'date-fns';
import ReactMarkdown from 'react-markdown';
import { IfElse } from '@buyhatke/react-ui';
import remarkGfm from 'remark-gfm';

import { CoinsList } from '@appComponents/bb-coinlistView';
import { Button, SEO, FaqItem, MarkdownComponents } from '@components';

// const illustrations = require.context('../img/', true, /\.(jpg|png|svg)$/);

const FSContent = ({
	completed,
	props: { heroImg, heading, coin, coinName, flashRegDeadline, flashTime },
	days,
	hours,
	minutes,
	seconds,
}) => {
	const sanitizedCoin = coin;
	const sanitizedHeading = heading;
	const sanitizedCoinName = coinName;

	return (
		<IfElse
			condition={completed}
			then={
				<>
					<div className="bg-primary text-white py-8">
						<div className="center-content container">
							<div className="center-content__box center-content__box--left">
								<div className="center-content__textWrapper">
									<h1 className="font-bold mb-0 mt-12 text-3xl">
										{sanitizedHeading}
									</h1>
									<p>
										Quickly go to the dashboard and grab{' '}
										{coin}s at our exclusive price!
									</p>
									<p>
										You can invest{' '}
										<b>maximum of &#8377;500 </b>
										to get benefited with the "50% off"
										offer.
									</p>
									<div className="my-8">
										<Button
											href="/trade/#/flashsale"
											triangle="right"
											variant="primary"
										>
											Join the Flash Sale
										</Button>
									</div>
								</div>
							</div>
							<div
								className="center-content__box center-content__box--right"
								style={{ marginBottom: '-40px' }}
							>
								<img
									src={heroImg}
									alt="Illustration"
									width="371"
								/>
							</div>
						</div>
					</div>
					<div className="bg-white border-b border-t border-gray-300 text-center">
						<div className="container py-12 px-4">
							<h3
								className="font-bold text-2xl my-4"
								id="flash-heading"
							>
								{!completed
									? `Register for ${coin} Flash Sale in India`
									: 'Flash Sale is Live'}
							</h3>
							<div id="flash-timeout">
								<p className="u-para--readable mx-auto text-center">
									Flash Sale has begun. Login and go to the
									dashboard quickly to make the purchase
								</p>

								{!completed ? (
									<div className="bb-fS__timer__Wrap my-4 justify-center">
										<div className="bb-fS__timer__Item">
											<div className="bb-fS__timer__Numbr">
												{days}
											</div>
											<div className="bb-fS__timer__Label">
												Days
											</div>
										</div>
										<div className="bb-fS__timer__Item">
											<div className="bb-fS__timer__Numbr">
												{hours}
											</div>
											<div className="bb-fS__timer__Label">
												Hours
											</div>
										</div>
										<div className="bb-fS__timer__Item">
											<div className="bb-fS__timer__Numbr">
												{minutes}
											</div>
											<div className="bb-fS__timer__Label">
												Minutes
											</div>
										</div>
										<div className="bb-fS__timer__Item">
											<div className="bb-fS__timer__Numbr">
												{seconds}
											</div>
											<div className="bb-fS__timer__Label">
												Seconds
											</div>
										</div>
									</div>
								) : (
									<div className="my-8">
										<Button
											href="/trade/#/flashsale"
											triangle="right"
											variant="primary"
										>
											Purchase Now
										</Button>
									</div>
								)}
							</div>
						</div>
					</div>
				</>
			}
			else={
				<>
					<div className="bg-primary text-white py-8">
						<div className="center-content container">
							<div className="center-content__box center-content__box--left">
								<div className="center-content__textWrapper">
									<h1 className="font-bold mb-8 mt-12 text-3xl">
										{sanitizedHeading}
									</h1>

									<p className="u-para--readable text-white">
										We provide you a platform to buy{' '}
										{sanitizedCoinName} in India at 50% off
										in our flash sale. So, you can buy{' '}
										{sanitizedCoin} tokens for &#8377;100
										and get {sanitizedCoin} tokens worth
										&#8377;200. This offer is sure to double
										the value of your investment, but you
										can only buy a maximum {sanitizedCoin}{' '}
										of &#8377;500 in this offer.
									</p>
									<p className="u-para--readable text-white my-8">
										<b>Please note:</b> You can invest
										maximum of &#8377;500 tokens worth
										&#8377;1000.
									</p>
									<div className="my-8">
										<Button
											href="/trade/#/flashsale"
											triangle="right"
											variant="primary"
										>
											Join the Flash Sale
										</Button>
									</div>
								</div>
							</div>
							<div
								className="center-content__box center-content__box--right"
								style={{ marginBottom: '-40px' }}
							>
								<img
									src={heroImg}
									alt="Illustration"
									width="371"
								/>
							</div>
						</div>
					</div>
					<div className="bg-white border-b border-t border-gray-300 text-center">
						<div className="container max-w-5xl mx-auto py-12 px-4">
							<h3
								className="font-bold text-2xl my-4"
								id="flash-heading"
							>
								The Mega {sanitizedCoinName} ({sanitizedCoin})
								Flash Sale has arrived!
								{/* {!props.completed
							? new Date(props.pageContext.metadata.flashRegDeadline) -
									new Date() <
							  0
								? 'Registrations for the flash sale are closed'
								: `Register for ${
										props.pageContext.metadata.coin
								  } Flash Sale in India`
							: 'Flash Sale is Live'} */}
							</h3>
							{/* <h4 className="text-lg my-4">
						The Mega {props.pageContext.metadata.coinName} (
						{props.pageContext.metadata.coin}) Flash Sale has arrived!
					</h4> */}
							<div id="flash-timeout">
								{new Date(flashRegDeadline) - Date.now < 0 && (
									<h4 className="text-center text-lg">
										However, you can still register to trade
										on Bitbns
									</h4>
								)}
								<p className="u-para--readable mx-auto text-left">
									Get ready for the {sanitizedCoinName} Flash
									Sale on Bitbns. The 'Mega{' '}
									{sanitizedCoinName} Flash Sale' will start
									on{' '}
									{dateFormat(
										new Date(flashTime),
										'dd-MMM h:mma'
									)}{' '}
									and just like the previous{' '}
									{sanitizedCoinName} flash sales, we are
									offering double the amount of{' '}
									{sanitizedCoin} you purchase
								</p>
								<p className="u-para--readable mx-auto text-left">
									You can invest <b>maximum of &#8377;500 </b>
									to get benefited with the "50% off" offer.
								</p>
								<h4 className="text-center text-lg font-bold mb-4 mt-12">
									Eligibility Criteria:
								</h4>{' '}
								<p className="u-para--readable mx-auto text-left mt-0">
									Following are some preconditions that apply
									for anyone who wants to participate in the
									sale:
								</p>
								<ul className="u-para--readable mx-auto text-left">
									<li>
										Click 'Install Now' to install the
										Buyhatke extension and keep it. Without
										the extension, you won’t be able to
										participate in the QTUM Flash Sale.
										<div className="mt-2 mb-8">
											<Button
												target="blank"
												rel="noopener noreferrer"
												size="tiny"
												href="https://chrome.google.com/webstore/detail/buyhatke/ojplmecpdpgccookcobabopnaifgidhf?referrer=utm_source=bitbnsFlashSalePage&utm_medium=bitbnsWeb"
											>
												Install Now
											</Button>
										</div>
									</li>
									<li>
										Now come back to the QTUM Flash Sale
										page, click the Sync button below, and
										register the same email ID that you have
										registered with Bitbns.
										<div className="mt-2 mb-8">
											<Button
												target="blank"
												rel="noopener noreferrer"
												size="tiny"
												href="https://compare.buyhatke.com/options/#price-alert-id"
											>
												Sync Now
											</Button>
										</div>
									</li>
									<li className="mb-8">
										Then, go to any of the Indian e-commerce
										website where coupons can be applied,
										add products to your cart, go to the
										checkout page, then find and click
										'Auto-Coupons' icon with the Buyhatke
										logo. Please note that completing the
										purchase is not mandatory in this
										process.
										<div className="mt-4">
											To learn more about applying
											'Auto-Coupons', watch a tutorial
											video in:{' '}
											<Button
												target="blank"
												rel="noopener noreferrer nofollow"
												size="tiny"
												variant="outline"
												href="https://www.youtube.com/watch?v=F1NmY4WYJJs"
												className="mr-4"
											>
												English
											</Button>
											<Button
												target="blank"
												rel="noopener noreferrer nofollow"
												size="tiny"
												variant="outline"
												href="https://www.youtube.com/watch?v=LIdy0V6B6dU"
											>
												Hindi
											</Button>
										</div>
									</li>
									<li className="mb-8">
										The Auto-Coupon feature will scan for
										the best discount(s) and display it in a
										popup window. Take a screenshot of this
										window, share it on either Twitter or
										Facebook.
									</li>
									<li className="mb-8">
										The last thing you have to do is click
										on 'Fill the form', and enter your
										Bitbns User ID and URL of the
										Facebook/Twitter post that you just
										shared.
										<div className="mt-2 mb-4">
											<Button
												target="blank"
												rel="noopener noreferrer nofollow"
												size="tiny"
												href="https://docs.google.com/forms/u/1/d/e/1FAIpQLSfg_306JAPMiN19K9sWvCv75oRCai-fEkHFz1LlYhjypVjwHw/viewform?usp=send_form"
											>
												Fill the form
											</Button>
										</div>
									</li>
									<li className="mb-8">
										Once you submit the form, we will verify
										your social media post, and release the
										eligibility for you to participate in
										the QTUM Sale.
									</li>

									<div className="mt-2 text-sm text-lightGray flex items-start">
										<span className="mr-2">***</span>{' '}
										<div>
											Check this space for updated
											criteria
										</div>
									</div>
								</ul>
								{/* <ul className="u-para--readable mx-auto text-left">
							<li>
							</li>
							<li>
								The registration for {props.pageContext.metadata.coin} flash
								sale will close on{' '}
								<b>
									{dateFormat(
										new Date(
											props.pageContext.metadata.flashRegDeadline
										),
										'DD-MMM h:mmA'
									)}{' '}
									IST
								</b>
								.
							</li>
						</ul> */}
								<p className="u-para--readable mx-auto text-left my-12">
									Once the countdown clock strikes zero, get
									ready to participate in the {sanitizedCoin}{' '}
									flash sale.
								</p>
								<h4>
									Flash sale will be held on{' '}
									{dateFormat(
										new Date(flashTime),
										'dd-MMM h:mma'
									)}{' '}
									IST
								</h4>
								<IfElse
									condition={!completed}
									then={
										<div className="bb-fS__timer__Wrap my-4 justify-center">
											<div className="bb-fS__timer__Item">
												<div className="bb-fS__timer__Numbr">
													{days}
												</div>
												<div className="bb-fS__timer__Label">
													Days
												</div>
											</div>
											<div className="bb-fS__timer__Item">
												<div className="bb-fS__timer__Numbr">
													{hours}
												</div>
												<div className="bb-fS__timer__Label">
													Hours
												</div>
											</div>
											<div className="bb-fS__timer__Item">
												<div className="bb-fS__timer__Numbr">
													{minutes}
												</div>
												<div className="bb-fS__timer__Label">
													Minutes
												</div>
											</div>
											<div className="bb-fS__timer__Item">
												<div className="bb-fS__timer__Numbr">
													{seconds}
												</div>
												<div className="bb-fS__timer__Label">
													Seconds
												</div>
											</div>
										</div>
									}
									else={
										<div className="my-8">
											<Button
												href="/trade/#/flashsale"
												triangle="right"
												variant="primary"
											>
												Purchase Now
											</Button>
										</div>
									}
								/>
							</div>
						</div>
					</div>
				</>
			}
		/>
	);
};

const BuyPages = props => {
	const {
		faqJson,
		content,
		coin,
		coinName,
		title,
		path,
		description,
		heading,
		flashSale,
		flashTime,
		flashText,
		faqText,
		hasTrade,
		heroImg,
	} = props;
	const faqHome = faqJson && faqJson.faqHome ? faqJson.faqHome : null;

	const url = `https://bitbns.com${path}/`;

	return (
		<>
			<SEO
				title={title}
				url={url}
				description={description}
				jsonLd={[
					`  {
							"@context": "https://schema.org",
							"@type": "Article",
							"mainEntityOfPage": {
								"@type": "WebPage",
								"@id": "${url}"
							},
							"headline": "${title}",
							"datePublished": "2018-01-01T08:00:00+08:00",
							"dateModified": "${formatISO(new Date())}",
							"author": {
								"@type": "Organization",
								"name": "Bitbns"
							}, "image": [
								"https://bitbns.com/img/logos/bns-512.png"
							],
							"publisher": {
								"@type": "Organization",
								"name": "Bitbns",
								"logo": {
								"@type": "ImageObject",
								"url": "https://bitbns.com/img/logos/bns-144.png"
								}
							},
							"description": "${description}"
							}`,
				]}
			/>

			<IfElse
				condition={flashSale}
				then={
					<IfElse
						condition={
							differenceInMinutes(
								Date.now(),
								new Date(flashTime)
							) > 3
						}
						then={
							<>
								<div className="bg-primary text-white py-8">
									<div className="center-content container">
										<div className="center-content__box center-content__box--left">
											<div className="center-content__textWrapper">
												<h1 className="font-bold mb-0 mt-12 text-3xl">
													The Flash Sale is Over
												</h1>
												<p className="u-para--readable text-white">
													However, you can still
													register to trade on Bitbns.
													<br />
													Stay tuned to be informed
													about the next flash sale
												</p>
												<div className="my-8">
													<Button
														href="/trade/#/"
														triangle="right"
														variant="primary"
													>
														Trade {coinName} Now
													</Button>
												</div>
											</div>
										</div>
										<div
											className="center-content__box center-content__box--right"
											style={{
												marginBottom: '-40px',
											}}
										>
											<img
												src={heroImg}
												alt="Illustration"
												width="371"
											/>
										</div>
									</div>
								</div>
								<CoinsList
									buy
									up
									singleLine
									coin={coin.toLowerCase()}
								/>
							</>
						}
						else={
							<div>
								<Countdown
									date={new Date(flashTime)}
									renderer={FSContent}
									{...props}
									heroImg={heroImg}
								/>
							</div>
						}
					/>
				}
				else={
					<>
						<div className="bg-primary text-white py-8">
							<div className="container">
								<h1 className="font-bold text-center my-0 text-3xl">
									{heading}
								</h1>
							</div>
						</div>
						<CoinsList
							buy
							up
							singleLine
							coin={coin.toLowerCase()}
						/>
					</>
				}
			/>

			{flashText ? (
				<div className="w-full bg-white py-10 pb-0 px-4">
					<div className="mx-auto u-para--readable container">
						<h3 className="text-xl">
							About {coinName} ({coin})
						</h3>
						{flashText.split('\\n').map((item, key) => (
							<p
								className="u-para--readable"
								key={`${coin}-${key}`}
							>
								{item.trim()}
								<br />
							</p>
						))}
					</div>
				</div>
			) : (
				''
			)}

			{!!faqHome && faqHome.length > 0 && !!flashSale ? (
				<div className="bg-white px-4">
					<div className="mx-auto pt-10 max-w-6xl">
						<h3 className="text-center text-lg">
							Frequently Asked Questions
						</h3>
						<p className="u-para--readable py-2">{faqText}</p>

						<div className="Grid Grid--fit margin-vertical-3x">
							<ol className="pl-8">
								{faqHome.map(({ q, a }) => (
									<FaqItem
										q={<ReactMarkdown>{q}</ReactMarkdown>}
										key={q}
										a={
											<ReactMarkdown
												components={{
													a: rmProps => (
														<a
															{...rmProps}
															target="_blank"
															rel="noreferrer noopener"
															className="font-bold c-links"
														/>
													),
													p: ({ children }) => (
														<p className="mb-4">
															{children}
														</p>
													),
												}}
											>
												{a}
											</ReactMarkdown>
										}
									/>
								))}
							</ol>
						</div>
					</div>
				</div>
			) : (
				''
			)}

			<div className="bg-white px-4">
				<div className="container pb-16">
					{!hasTrade && (
						<div className="mx-auto u-para--readable pt-4">
							<em>
								<b>Note:</b> {coinName} is not yet live for
								trading, but we would add it soon. Till then,
								sign up and explore seamless trading at Bitbns.
							</em>
						</div>
					)}
					<div className="mx-auto u-para--readable pt-4">
						<ReactMarkdown
							components={MarkdownComponents}
							remarkPlugins={[remarkGfm]}
						>
							{content}
						</ReactMarkdown>
					</div>
				</div>
			</div>

			<CoinsList price />
		</>
	);
};

export default BuyPages;
